export default "__VITE_ASSET__e65d2dbc__"